<div
    style="height: 300px; background-color: #ddd"
    *ngIf="isLoading && (findingEmployee || shareInProgress)"
    fxLayout="row"
    fxLayoutAlign="center center"
>
    <mat-spinner
        [diameter]="60"
        mode="indeterminate"
        [color]="'primary'"
    ></mat-spinner>
</div>
<div *ngIf="!isLoading" style="max-height: 800px; background-color: #fafafa">
    <div
        class="delta-dialog-toolbar h-64 pl-24 pr-24 pt-20 pb-20"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <span class="title">{{ 'Share with' | translate }}</span>
        <mat-icon
            class="close cursor-pointer"
            matTooltip="{{ 'CLOSE_DIALOG' | translate }}"
            matTooltipPosition="above"
            (click)="onNoClick()"
            >close</mat-icon
        >
    </div>
    <mat-tab-group #tabGroup (selectedTabChange)="tabChanged($event)">
        <mat-tab label="ROLES">
            <div class="m-24">
                <mat-chip-set>
                    <mat-chip
                        fxLayout="column"
                        fxLayoutAlign="center center"
                        *ngFor="let role of roles"
                        [ngClass]="{
                            'chip-active': selectedRoles.includes(role.Key)
                        }"
                        [disabled]="role.Key == 'admin'"
                        (click)="selectRole(role.Key)"
                    >
                        <span class="font-14">{{
                            role.Title | translate
                        }}</span>
                    </mat-chip>
                </mat-chip-set>
            </div>
        </mat-tab>
        <mat-tab label="INDIVIDUALS">
            <div class="mx-24 my-8" fxLayout="column">
                <mat-progress-bar *ngIf="findingEmployee" mode="indeterminate">
                </mat-progress-bar>
                <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{ 'Choose Employee' | translate }}</mat-label>
                    <input
                        matInput
                        class="w-100-p"
                        [formControl]="employeeSearchControl"
                    />
                    <mat-icon matSuffix class="mat-icon-color">search</mat-icon>
                </mat-form-field>
                <mat-chip-set
                    *ngIf="selectedEmployees.length > 0"
                    class="mb-16"
                    style="
                        max-height: 84px;
                        overflow-y: scroll;
                        overflow-x: hidden;
                        min-height: 44px;
                    "
                >
                    <mat-chip
                        *ngFor="
                            let employee of selectedEmployees;
                            let i = index
                        "
                        [removable]="true"
                        (removed)="removeEmployee(employee)"
                    >
                        {{ employee.DisplayName }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-set>
                <div
                    *ngIf="filteredEmployee.length > 0"
                    fxLayout="row wrap"
                    fxLayout.xs="column"
                    fxLayoutGap="8px grid"
                    style="max-height: 300px; overflow: scroll !important"
                >
                    <div
                        *ngFor="let employee of filteredEmployee; let i = index"
                        fxFlex="50"
                    >
                        <div
                            fxFlex="100"
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            class="h-64 employee-list-item p-8 cursor-pointer"
                            [ngClass]="{
                                'grey-border': !employee.Selected,
                                'blue-border': employee.Selected
                            }"
                            (click)="selectEmployee(employee)"
                        >
                            <div *ngIf="!employee.Selected">
                                <!-- <div *ngIf="!employee?.ProfileImageId" class="contact-icon m-8">
									<mat-icon>person</mat-icon>*ngIf="employee?.ProfileImageId"
								</div> -->
                                <!-- <div class="m-8">
									<load-avatar-image [imageId]="employee.ProfileImageId" 
									[imageType]="'dms'" [displayName]="employee.DisplayName">
									</load-avatar-image>
								</div> -->
                            </div>
                            <div *ngIf="employee.Selected">
                                <div class="contact-icon-selected m-8">
                                    <mat-icon>done</mat-icon>
                                </div>
                            </div>
                            <div fxLayout="column">
                                <span class="name text-truncate">{{
                                    employee?.DisplayName
                                }}</span>
                                <span class="id"
                                    >EMP-{{ employee?.PersonnelNumber }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <mat-divider></mat-divider>
    <div
        mat-dialog-actions
        class="mx-24 my-4"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <button mat-button class="delta-button" (click)="onNoClick()">
            {{ 'APP_PLATFORM_DOCUMENT_MANAGER.CANCEL' | translate }}
        </button>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <button
                *ngIf="data.Type == 'File' && selectedTabIndex == 1"
                mat-raised-button
                class="delta-button w-10"
                (click)="shareViaEmail()"
                [disabled]="!isChanged"
            >
                {{ 'SEND VIA EMAIL' | translate }}
            </button>
            <button
                mat-raised-button
                class="delta-button w-100"
                color="primary"
                (click)="share()"
                [disabled]="!isChanged"
            >
                {{ 'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SHARE' | translate }}
            </button>
        </div>
    </div>
</div>
